<div class="picture" *ngIf="imageOptions" [ngClass]="{ 'width-fit': fitByWidth, 'height-fit': fitByHeight, 'contain-fit': fitByContain }">
    <img *ngIf="isSVG" [src]="imageUrl" [alt]="imageOptions.alt" />
    <img *ngIf="!isSVG" [src]="imageUrl" [attr.srcset]="imageUrl2x" [alt]="imageOptions.alt" />
</div>
